/**
 * Created by Mikhail Menshenin on 30.07.2024
 */

cleverapps.NodeDebugCommands.move.action = cleverapps.extendFunc(cleverapps.NodeDebugCommands.move.action, function (arrowKey) {
    this._super(arrowKey);

    if (!cleverapps.flags.villageHutMove) {
        return;
    }

    let villageStyles, item, defaults;
    if (this instanceof HutView) {
        villageStyles = cleverapps.styles.HutView.villages;
        item = this.hut;
        defaults = 5;
    } else if (this instanceof CrossView) {
        villageStyles = cleverapps.styles.CrossView.villages;
        item = this.cross;
        defaults = 4;
    } else {
        return;
    }

    const village = item.village.level;
    const position = this.getPosition();
    const modes = cleverapps.resolution.mode ? [1, 2] : [0];

    let positions = villageStyles[village] || cleverapps.rangeArray(0, defaults - 1).map(() => [{}, {}, {}]);
    if (!Array.isArray(positions)) {
        positions = Object.values(positions);
    }
    villageStyles[village] = positions;

    const itemPositions = positions[item.id] || [{}, {}, {}];
    positions[item.id] = itemPositions;

    modes.forEach((mode) => {
        itemPositions[mode] = position;
    });
});

cc.Base.prototype.createEditButtons = cleverapps.extendFunc(cc.Base.prototype.createEditButtons, function (options) {
    const layout = this._super(options);

    if (options.noResLinks || !(this instanceof HutView || this instanceof CrossView)) {
        return layout;
    }

    const styles = cleverapps.styles.NodeDebug.button;

    const editPositionButton = new cleverapps.UI.Button({
        type: cleverapps.styles.UI.Button.Images.small_button_green,
        content: cleverapps.UI.generateOnlyText("P", cleverapps.UI.Button.WorkFont()),
        hint: "Toggle edit position mode",
        onClicked: () => cleverapps.flags.toggle("villageHutMove"),
        width: styles.width,
        height: styles.height
    });
    editPositionButton.alwaysOn = true;

    const updateEditPositionButton = () => {
        editPositionButton.setType(cleverapps.flags.villageHutMove ? cleverapps.styles.UI.Button.Images.small_button_blue : cleverapps.styles.UI.Button.Images.small_button_green);
    };

    cleverapps.flags.on("change:villageHutMove", updateEditPositionButton, editPositionButton);
    updateEditPositionButton();

    return new cleverapps.Layout([layout, editPositionButton].filter(Boolean), {
        direction: cleverapps.UI.HORIZONTAL,
        margin: styles.margin
    });
});
